import { AxiosError } from 'axios';
import { metric } from '../metric';

/**
 * Extract the status code from the error
 * @param error
 * @returns {string} status code
 */
export const getStatusCode = (error: AxiosError) => {
    const errorCode = error?.code?.toString()?.toLowerCase();
    const statusCode = error?.response?.status;

    return statusCode || errorCode;
};

export const measureOnSuccess = ({
    routeId,
    startTime,
    status,
    requestType = 'http',
}: {
    routeId: string;
    startTime: number;
    status: unknown;
    requestType?: 'http' | 'sdk';
}) => {
    metric.time(`${requestType}.${routeId}.total_request_time`, Date.now() - startTime);
    metric.count(`${requestType}.${routeId}.request`);
    metric.count(`${requestType}.${routeId}.result.status.${status}`);
};

export const measureOnFailure = ({
    routeId,
    startTime,
    status,
    requestType = 'http',
}: {
    routeId: string;
    startTime: number;
    status: unknown;
    requestType?: 'http' | 'sdk';
}) => {
    metric.time(`${requestType}.${routeId}.failure_total_request_time`, Date.now() - startTime);
    metric.count(`${requestType}.${routeId}.request`);

    if (status) {
        metric.count(`${requestType}.${routeId}.result.status.${status}`);
    }
};
